export function makeAttendanceItems(data) {
    const attendance = data?.dispatch?.attendance ?? {};

    return [
        {
            label: "Protocolo",
            value: attendance?.attendance_protocol ?? "",
        },
        {
            label: "Natureza",
            value: attendance?.attendance_nature ?? "",
        },
        {
            label: "Inicio",
            value: attendance?.attendance_start ?? "",
        },
        {
            label: "Fim",
            value: attendance?.attendance_end ?? "",
        },
    ];
}